import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type UpdatePartsRunMutationVariables = Types.Exact<{
  id: Types.Scalars['bigint']['input'];
  set: Types.Mobility_Runs_Set_Input;
}>;


export type UpdatePartsRunMutation = { __typename?: 'mutation_root', update_mobility_runs_by_pk?: { __typename?: 'mobility_runs', id: number } | null };


export const UpdatePartsRunDocument = gql`
    mutation updatePartsRun($id: bigint!, $set: mobility_runs_set_input!) {
  update_mobility_runs_by_pk(pk_columns: {id: $id}, _set: $set) {
    id
  }
}
    `;
export type UpdatePartsRunMutationFn = Apollo.MutationFunction<UpdatePartsRunMutation, UpdatePartsRunMutationVariables>;

/**
 * __useUpdatePartsRunMutation__
 *
 * To run a mutation, you first call `useUpdatePartsRunMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePartsRunMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePartsRunMutation, { data, loading, error }] = useUpdatePartsRunMutation({
 *   variables: {
 *      id: // value for 'id'
 *      set: // value for 'set'
 *   },
 * });
 */
export function useUpdatePartsRunMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePartsRunMutation, UpdatePartsRunMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePartsRunMutation, UpdatePartsRunMutationVariables>(UpdatePartsRunDocument, options);
      }
export type UpdatePartsRunMutationHookResult = ReturnType<typeof useUpdatePartsRunMutation>;
export type UpdatePartsRunMutationResult = Apollo.MutationResult<UpdatePartsRunMutation>;
export type UpdatePartsRunMutationOptions = Apollo.BaseMutationOptions<UpdatePartsRunMutation, UpdatePartsRunMutationVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/partsDelivery/queries/updatePartsRun.mutation.gql}
 */
export async function updatePartsRun(
  variables: UpdatePartsRunMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<UpdatePartsRunMutation['update_mobility_runs_by_pk']>
export async function updatePartsRun(
  variables: UpdatePartsRunMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<UpdatePartsRunMutation>
export async function updatePartsRun(
  variables: UpdatePartsRunMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<UpdatePartsRunMutation['update_mobility_runs_by_pk'] | UpdatePartsRunMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<UpdatePartsRunMutation>(
    UpdatePartsRunDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.update_mobility_runs_by_pk
}